const StickerEnvelope = {
    buying: false,
    loading: false,
    open: function(promo_id, cost) {

        let prizeContainer = document.getElementById('promo_getted_stickers');
        let containerPromo = document.getElementById('container_envelope_promo');

        if (!StickerEnvelope.buying) {
            StickerEnvelope.buying = true;
            prizeContainer.innerHTML = '';
            // Api call
            Api.post('/stickersenvelope/open', {type: promo_id}, function (r) {
                if (r.success) {
                    let htmlDataRender = '';
                    let coins = document.getElementById('account_coins').innerText;
                    let new_amount = parseInt(coins,10) - cost;
                    document.getElementById('account_coins').innerText = new_amount;

                    for (let i = 0; i<r.data.length; i++) {
                        htmlDataRender += `
                            <div class="icon_expositor" style="padding: 0">
                                <div rel="tooltip" data-name="${r.data[i].name} <span style=font-size:12px;font-weight:bold;>(${r.data[i].type})</span>" data-description="${r.data[i].description}" style="background: url(/images/stickers_container.png),url(${r.data[i].image});background-size: 80px 80px,80px 80px;width:80px;height: 80px;margin:10px;"></div>
                           </div>
                        `
                    }
                    Alert.push([{type: 'success', text: 'Los stickers se han añadido a tu cuenta.', icon: 'check'}]);

                    prizeContainer.innerHTML = htmlDataRender;
                    StickerEnvelope.buying = false;

                } else {
                    switch (r.error.identifier) {
                        case 'promo_not_found':
                            Alert.push([{type: 'danger', text: '¡Oops! La promoción seleccionada no existe.', icon: 'warning-sign'}]);
                            break;
                        case 'coins_insufficient':
                            Alert.push([{type: 'danger', text: '¡Oops! No tienes los fondos suficientes.', icon: 'warning-sign'}]);
                            break;
                        case 'internal_error_withdrwaing_coins':
                            Alert.push([{type: 'danger', text: '¡Oops! No hemos podido procesar esta transacción..', icon: 'warning-sign'}]);
                            break;
                        case 'error_picking_amount_stickers':
                            Alert.push([{type: 'danger', text: '¡Oops! Algo ha ido mal y no hemos podido entregarte los stickers.', icon: 'warning-sign'}]);
                            break;
                    }
                    StickerEnvelope.buying = false;
                }
            });

        } else {
            Alert.push([{type: 'danger', text: '¡Calma máquina! Estamos procesando tu solicitud.', icon: 'warning-sign'}]);
        }

    }

}
